import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {Divider} from '../layout/divider';
import {Link} from '../link/link';
import {BoldLabel} from '../typography/bold-label';

import {FieldCheckboxes} from './field-checkboxes';
import type {EntityFormType, SelectableField} from './types';

type Props = {
    nutshellFields: any[];
    customFields: any[];
    selectedFields: SelectableField[];
    entityType: EntityFormType;
    handleCheckboxToggle: (fieldKey: string) => void;
    isLeadCard?: boolean;
};

export function SelectFields(props: Props) {
    return (
        <>
            <div className='pad-16'>
                <BoldLabel>Nutshell fields</BoldLabel>
                <FieldCheckboxes
                    fields={props.nutshellFields}
                    fieldList={props.selectedFields}
                    onChange={(fieldName: string) => props.handleCheckboxToggle(fieldName)}
                    entityType={props.entityType}
                    isLeadCard={props.isLeadCard}
                />
            </div>
            <Divider variant='line--horizontal' />
            <div className='pad-16'>
                <div className='flex justify-sb'>
                    <BoldLabel>Custom fields</BoldLabel>
                    <Link
                        // @ts-expect-error
                        as={RouterLink}
                        size='small'
                        to={
                            NutClientConfig.hasPerPipelineCustomFields
                                ? `/setup/custom-field`
                                : '/setup/custom-field-old'
                        }
                        variant='primary'
                        newTab={true}
                    >
                        Manage custom fields
                    </Link>
                </div>
                <FieldCheckboxes
                    fields={props.customFields}
                    fieldList={props.selectedFields}
                    onChange={(fieldName: string) => props.handleCheckboxToggle(fieldName)}
                    entityType={props.entityType}
                />
            </div>
        </>
    );
}
